import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { TaskInsightsData } from 'edrolo/domains/coursePortal/types/Insights';
import { useQueryParams } from 'edrolo/domains/coursePortal/hooks';

export const useTaskInsights = (taskId: TaskId) => {
  const { queryParams } = useQueryParams();
  const { data, isLoading, error } = useSWR<TaskInsightsData>(
    urlResolver.query('api:task-insights', { taskId }, queryParams)
  );

  return {
    data,
    error,
    isLoading,
  };
};
